import { render, staticRenderFns } from "./banner-news.vue?vue&type=template&id=01eb1f3f&"
import script from "./banner-news.vue?vue&type=script&lang=js&"
export * from "./banner-news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports